import { AbstractControl, ValidationErrors, Validator } from "@angular/forms";

export abstract class BaseValidator implements Validator {
    
    protected _onChange: () => void;

    protected get validatorKey(): string {
            return this._validatorKey;
    }

    private _validatorKey: string;

    protected constructor(validatorKey: string) {
            this._validatorKey = validatorKey;
    }

    public readonly validate = (control: AbstractControl): ValidationErrors | null => {
            return this.validateInternalAsync(control);
    };

    public readonly registerOnValidatorChange = (fn: () => void): void => { this._onChange = fn; };

    protected abstract getValidationResult(control: AbstractControl): ValidationErrors | null;

    protected buildValidationErrorResult(result: any): ValidationErrors {
            const error: ValidationErrors = {};

        error[this._validatorKey] = result;

        return error;
    }

    private validateInternalAsync(control: AbstractControl): ValidationErrors | null {
    
        try {
                const result = this.getValidationResult(control);

            if(result){
                    control.markAsTouched();
            }

            return result;
        }
        catch (e) {
                control.markAsTouched();

            return this.buildValidationErrorResult({ error: e });
        }
    }
}